import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import {
  Overlay,
  ModalContainer,
  ModalHeader,
  ModalBody,
  CloseButton
} from './component-modal.styles';

const ComponentModal = ({ isOpen, onClose, title = null, children }) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {title && (
          <ModalHeader>
            <h2>{title}</h2>
            <CloseButton onClick={onClose}>&times;</CloseButton>
          </ModalHeader>
        )}
        <ModalBody>{children}</ModalBody>
      </ModalContainer>
    </Overlay>,
    document.getElementById('modal-root') // make sure this exists in index.html
  );
};

export default ComponentModal;